<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}
</style>

<template>
  <!-- 开启手机验证 - 开始 -->
  <Modal
    v-model="vis"
    :loading="true"
    :mask-closable="false"
    @on-ok="okHandle"
    @on-cancel="cancelHandle"
    :title="$t('安全验证')"
  >
    <div class="modal-item">
      <h3>{{ $t('谷歌验证码') }}</h3>
      <input type="text" v-model.trim="code.google" />
    </div>
  </Modal>
  <!-- 开启手机验证 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
// 引入 vuex 中的用户信息
import { mapState } from 'vuex'
import {
  ajaxSmsHandle,
  ajaxTry,
  updateUserInfo,
  ajaxAlert,
  ajaxTip
} from '@/utils'
import { ajax_sendSms, ajax_openOrCloseSafeVerify } from '@/api/personal'

export default {
  name: 'OpenGoogleVerifyModal',
  extends: ModalBase,
  computed: {
    ...mapState(['userInfo'])
  },
  inject: {
    safeVerifyInfo: 'safeVerifyInfo',
    whetherVerify: 'whetherVerify'
  },
  data() {
    return {
      code: {
        google: ''
      }
    }
  },
  mounted() {},
  methods: {
    async okHandle() {
      // 判断必要填写的验证码有没有空的，
      if (this.code.google === '') {
        this.$Message.info(this.$t('请填写谷歌验证码！'))
        return
      }
      // 发送安全验证请求
      let ajaxParam = {
        ...this.safeVerifyInfo,
        ...{
          googleCode: this.code.google
        }
      }
      let [flag] = await ajaxTry(ajax_openOrCloseSafeVerify(ajaxParam))
        .then(ajaxAlert)
        .then(updateUserInfo)
      if (flag) this.vis = false
    },
    cancelHandle() {
      // 改变外部的i-switch 状态
      let flag = this.whetherVerify[this.whetherVerify.currentISwitch]
      this.whetherVerify[this.whetherVerify.currentISwitch] = !flag
    }
  }
}
</script>
